(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle',event=>{const item=event.target;if(!item.matches('.zuqo-mobile-menu__details, .zuqo-mobile-menu__nested-details'))return;item.querySelector(':scope > summary')?.setAttribute('aria-expanded',item.open?'true':'false');if(!item.matches('.zuqo-mobile-menu__details')||!item.open)return;document.querySelectorAll('.zuqo-mobile-menu__details[open]').forEach(opened=>{if(opened!==item)opened.removeAttribute('open')})},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-short-video"] && !Shopify.designMode) return;
  try {
    const initializeProductVideos = (root = document) => {
    root.querySelectorAll('[data-zuqo-product-video]').forEach((component) => {
      if (component.dataset.videoReady) return;
      component.dataset.videoReady = 'true';
      const dialog = component.querySelector('[data-zuqo-video-dialog]');
      const player = component.querySelector('.zuqo-product-video__player');
      const openButton = component.querySelector('[data-zuqo-video-open]');
      const closeButton = component.querySelector('[data-zuqo-video-close]');
      const closeVideo = () => {
        player?.pause();
        if (dialog?.open) dialog.close();
        document.body.classList.remove('overflow-hidden');
      };
      openButton?.addEventListener('click', () => {
        if (!dialog) return;
        dialog.showModal();
        document.body.classList.add('overflow-hidden');
        player?.play().catch(() => {});
      });
      closeButton?.addEventListener('click', closeVideo);
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) closeVideo();
      });
      dialog?.addEventListener('close', () => {
        player?.pause();
        document.body.classList.remove('overflow-hidden');
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeProductVideos());
  } else {
    initializeProductVideos();
  }
  document.addEventListener('shopify:section:load', (event) => initializeProductVideos(event.target));
  } catch(e) { console.error(e); }
})();

})();
